import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import async from 'async'

// Constants
import { API_URL } from '../../../../../constants'

// Components
import Dropzone from '../../../../../shared/components/Dropzone'
import Confirm from '../../../../../shared/components/Confirm'
import Portal from '../../../../../shared/components/Portal'
import { fileUpload, fileDelete, postOccurrenceFile } from '../../../../../actions/tasks'
import { translation } from '../../../../../utils/helpers'
import { postNote } from '../../../../../actions/generalnotes'

import { renderFullDate } from '../../../../../utils/time'

import './index.scss'
import Panel from '../../../../../shared/elements/panel'
import Textarea from '../../../../../shared/elements/textarea'
import LabelWrapper from '../../../../../shared/elements/labelWrapper'
import Image from '../../../../../shared/elements/image'

class Files extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      upload: {
        loading: false,
        errors: []
      },
      files: [],
      confirmFileDelete: {
        confirm: false,
        file: null
      },
      mounted: false
    }
    this.renderFiles = this.renderFiles.bind(this)
  }

  componentDidMount () {
    this.setState({
      files: this.props.files,
      confirmFileDelete: {
        confirm: false,
        file: null
      },
      mounted: true
    })
  }

  componentWillReceiveProps (nextProps) {
    this.setState({
      files: nextProps.files,
      confirmFileDelete: {
        confirm: false,
        file: null
      },
      mounted: true
    })
  }

  componentWillUnmount () {
    this.setState({
      mounted: false
    })
  }

  renderFiles () {
    let { errors } = this.state.upload

    // Delete file
    const deleteFile = (file) => {
      let newErrors = []
      var deleteFileId = {ItemId: file.OrderFileId}
      this.props.fileDelete(deleteFileId).then((res) => {
        // delete from database
        this.setState({
          files: this.state.files.filter((el) => { return el.OrderFileId !== Number(file.OrderFileId) })
        })
      }, () => {
        newErrors.push(translation('1207') + ': ' + file.FileName)
        this.setState({
          upload: { ...this.state.upload, errors: newErrors }
        })
      })
    }

    const deleteConfirmation = file => {
      this.setState({
        confirmFileDelete: {
          confirm: true,
          file: file
        }
      })
    }

    // Render file
    const renderFile = (file, index) => {
      const info = () => {
        return (
          <div className='info'>
            <div>{translation('15357')}: {file.CreatedBy}</div>
            <div>{translation('15358')}: {renderFullDate(file.CreatedDate)}</div>
          </div>
        )
      }

      const postNote = () => {
        let data = this.state.files[index].Notes[0]
        if (isNaN(data.OrderFileId)) data.OrderFileId = file.OrderFileId
        this.props.postNote(data).then((res) => {
          let files = this.state.files
          files[index].Notes = res.data
          this.setState({
            files: files
          }, () => {
            // window.toastr.success(translation('1931'), translation('13424'))
          })
        }, () => {
          // Toastr
          window.toastr.error(translation('960'), translation('216'))
        })
      }

      const noteChange = (e) => {
        let files = this.state.files
        files[index].Notes[0] = {
          ...files[index].Notes[0],
          Note: e.target.value
        }
        this.setState({
          files: files
        }, this.forceUpdate)
      }

      let note = file.Notes.length > 0 ? file.Notes[0].Note : ''
      return (
        <div key={index}>
          {file.IsImage ? (
            <div className='top clearfix'>
              {renderImage(file)}
              {info()}
            </div>
            ) : renderNonImage(file)}
          {file.IsImage === false && info()}
          <div className='note'>
            <LabelWrapper labelText={translation('15359')}>
              <Textarea value={note} onChange={noteChange} onBlur={postNote} />
            </LabelWrapper>
          </div>
        </div>
      )
    }

    // Render non image
    const renderNonImage = (file) => {
      let thumbUrl = API_URL + '/FileService/GetIcon?fileName=' + file.FileName
      return (
        <div className='nonimage'>
          <img className='file-icon' alt='icon' src={thumbUrl} />
          <a target='_BLANK' href={file.FileURL}>
            {file.FileName}
          </a>
          <img className='file-delete' src='/images/icons/Delete_16.png' onClick={() => deleteConfirmation(file)} />
        </div>
      )
    }
    // Render image
    const renderImage = (image) => {
      return (
        <div className='gallery'>
          <Image imageFile={image} onClickDelete={() => deleteConfirmation(image)} />
        </div>
      )
    }

    const onConfirm = () => {
      const file = this.state.confirmFileDelete.file
      const confirm = {
        confirm: false,
        file: null
      }

      this.setState({
        confirmFileDelete: confirm
      }, () => {
        deleteFile(file)
      })
    }

    const notConfirm = () => {
      const confirm = {
        confirm: false,
        file: null
      }
      this.setState({
        confirmFileDelete: confirm
      })
    }
    // On drop
    const onDrop = () => {
      this.setState({ upload: {
        ...this.state.upload,
        errors: []
      } })
    }
    // On drop accepted
    const onDropAccepted = (files) => {
      let newErrors = []
      this.setState({
        upload: {
          ...this.state.upload,
          loading: true
        }
      })
      async.each(files, (file, cb) => {
        // Upload each file
        this.props.fileUpload(file, 0).then((res) => {
          this.props.postOccurrenceFile({ OccurrenceId: this.props.OccurrenceId, OrderFileId: res.data[0].OrderFileID }).then((files) => {
            this.setState({
              files: files.data
            })
          })
          cb()
        }, () => {
          newErrors.push(translation('1207') + ': ' + file.name + ' ' + translation('13406') + '.')
          cb()
        })
      }, () => {
        if (newErrors.length !== 0) {
          this.setState({
            upload: {
              ...this.state.upload,
              errors: this.state.upload.errors.concat(newErrors)
            }
          })
        }
        this.setState({
          upload: {
            ...this.state.upload,
            loading: false
          }
        })
      })
    }
    // On drop rejected
    const onDropRejected = (files) => {
      let newErrors = []
      files.map((val, index) => {
        newErrors.push(translation('1207') + ': ' + val.name + ' ' + translation('13405') + '.')
      })
      this.setState({ upload: { ...this.state.upload, errors: newErrors } })
    }
    // Render error
    const renderError = (error, index) => <p key={index}>{error}</p>
    // Render
    let isMultipleUpload = true
    return (
      <Panel title={translation('1043')}>
        <div className='files'>
          {/* <div className='taskhead'>
            <img className='icon' src='/images/svgs/inspection/files.svg' />
            <div>{translation('1043')}</div>
          </div> */}
          <div className='files_inner clearfix'>
            {this.state.files && this.state.files.map(renderFile)}
          </div>
          {errors.length !== 0 && <div className='alert alert-danger'>{errors.map(renderError)}</div>}
          <Dropzone
            onDrop={onDrop}
            onDropAccepted={onDropAccepted}
            onDropRejected={onDropRejected}
            multiple={isMultipleUpload}
            includeCircles={false}>
            {this.state.upload.loading && (
              <div className='loading'>
                <div className='animated-background'>
                  <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
                  <span className='sr-only'>{translation('13382')}...</span>
                </div>
              </div>
            )}
            {!this.state.upload.loading && (
              <div><p>{translation('13397')}</p></div>
              )}
          </Dropzone>
          {this.state.confirmFileDelete.confirm && (
            <Portal className='deleteModal' onPortalClose={notConfirm}>
              <Confirm confirm={onConfirm} notConfirm={notConfirm} />
            </Portal>
          )}
        </div>
      </Panel>
    )
  }

  render () {
    return (
      <div className='white__box'>
        {this.renderFiles()}
      </div>
    )
  }
}

Files.contextTypes = {
  router: PropTypes.object.isRequired
  // t: React.PropTypes.func.isRequired,
  // enum: React.PropTypes.func.isRequired
}
function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {
  fileUpload,
  fileDelete,
  postOccurrenceFile,
  postNote
})(Files)



// WEBPACK FOOTER //
// ./src/app/pages/MyPage/MyTasks/Task/Files/index.js